import { CommonDependency } from '@/dependency';
import { useMutation, useQuery } from 'react-query';

export const useParseInviteLink = () => {
  return useMutation(async ({ chatType, inviteLink }: { chatType: string; inviteLink: string }) => {
    return CommonDependency.api.parseInviteLink({ chatType, inviteLink });
  });
};

export const useParseTwitterLink = (actionType: string) => {
  return useMutation(async ({ link, hashtags }: { link: string; hashtags?: string[] }) => {
    return CommonDependency.api.parseTwitterLink({ actionType, link, hashtags });
  });
};

type TokenDetail = {
  display_symbol?: string;
  symbol: string;
  logo_url: string;
  id: string;
};

type CollectionDetail = {
  name: string;
  logo_url: string;
  id: string;
};

export const useTokenDetail = ({ chainId, id }: { chainId: string; id: string }) => {
  return useQuery<{ token: TokenDetail }>(
    ['token-detail', chainId, id],
    async () => CommonDependency.api.getTokenDetail({ chainId, id }),
    {
      enabled: !!chainId && !!id,
    },
  );
};

export const useCollectionDetail = ({ chainId, id }: { chainId: string; id: string }) => {
  return useQuery<{ collection: CollectionDetail }>(
    ['collection-detail', chainId, id],
    async () => CommonDependency.api.getCollectionDetail({ chainId, id }),
    {
      enabled: !!chainId && !!id,
    },
  );
};

export const useGetContractDetail = () => {
  return useMutation(async ({ chainId, contractId }: { chainId: string; contractId?: string }) => {
    return CommonDependency.api.getContractDetail({ chainId, id: contractId });
  });
};

type ValidateSheetRes = {
  is_valid: boolean;
  reason: string;
  total_count: number; // 合法的地址数量，
  user_status: boolean; // 表示用户校验结果，
};

export const useValidateSheetUrl = () => {
  return useMutation(async ({ dataUrl }: { dataUrl: string }): Promise<ValidateSheetRes> => {
    return CommonDependency.api.validateSheetUrl(dataUrl);
  });
};

export const useValidateApiUrl = () => {
  return useMutation(
    async ({ dataUrl, headers }: { dataUrl: string; headers?: Record<string, string> }) => {
      return CommonDependency.api.validateApiUrl({ dataUrl, headers });
    },
  );
};
